import { getChildItemIdFromBomSelectionForLite, getIsLiteParentChildItem } from '../lite/selectors';
import { getFinalBomOptionsSelection, getQuantity, getQuantityValidation, getQuestion } from '../bom/selectors';
import { getIfCurrentBrandNeedsToRecalculatePrice, getItemId, getParameters, getShipping } from '../main/selectors';
import { priceRecalculationFailed, savePriceRecalculationResponse, startPriceRecalculation } from './actions';

import { BASE_API } from '../utils/base';
import { NumericValueOfNotAvailable } from '../utils/constants';
import { YearQuestionCode } from '../bom/constants';
import axios from 'axios';
import { getPrice } from '../price/selectors';

export const getShippingChargeAsync = (quantity, total, cancelTokenSource, handleShippingChargeCallback) => {
  return (dispatch, getState) => {
    const state = getState();
    const childItemId = getChildItemIdFromBomSelectionForLite(state);
    const isLiteParentChildItem = getIsLiteParentChildItem(state);
    const itemId = getItemId(state);
    const parameters = getParameters(state);
    const shipping = getShipping(state);

    const { coupon, vendorId, sample, zip } = parameters;
    const { methodId } = shipping;
    const request = {
      coupon: coupon || '',
      isSample: sample || false,
      itemId: isLiteParentChildItem ? childItemId : itemId,
      quantity,
      shippingMethodId: methodId || '',
      total,
      vendorId,
      zip: zip || '',
    };
    console.log('Shipping Request:');
    console.log(request);

    const headers = {
      APL_Token: sessionStorage.getItem('apl_token') || '',
      'Cache-Control': 'no-cache',
    };

    return axios({
      method: 'post',
      baseURL: BASE_API().trimEnd('/'),
      url: '/api/v1/shipping',
      data: request,
      headers,
      cancelToken: cancelTokenSource.token,
    })
      .then((response) => {
        sessionStorage.setItem('apl_token', response.headers['apl_token']);
        sessionStorage.setItem('apl_token_timeout', response.headers['apl_token_timeout']);
        return response;
      })
      .then((response) => {
        console.log('Shipping Response:');
        console.log(response);
        handleShippingChargeCallback({ ...response.data, isCalculating: false });
      })
      .catch((error) => {
        let isCalculating, isTbd;
        if (axios.isCancel(error)) {
          console.log('Shipping request was cancelled!');
          isCalculating = true;
          isTbd = false;
        } else {
          console.log('Shipping Error:');
          isCalculating = false;
          isTbd = true;
        }
        console.log(error);
        handleShippingChargeCallback({
          isCalculating,
          isTbd,
          shippingCharge: NumericValueOfNotAvailable,
          shippingMethodId: '',
        });
      });
  };
};

export const getShippingMethodsAsync = (quantity, total, cancelTokenSource, handleShippingMethodsCallback) => {
  return (dispatch, getState) => {
    const state = getState();
    const childItemId = getChildItemIdFromBomSelectionForLite(state);
    const isLiteParentChildItem = getIsLiteParentChildItem(state);
    const itemId = getItemId(state);
    const parameters = getParameters(state);
    const shipping = getShipping(state);

    const { coupon, vendorId, sample, zip } = parameters;
    const request = {
      coupon: coupon || '',
      isSample: sample || false,
      itemId: isLiteParentChildItem ? childItemId : itemId,
      quantity,
      shippingMethodId: '',
      total,
      vendorId,
      zip: zip || '',
    };
    console.log('Shipping Methods Request:');
    console.log(request);

    const headers = {
      APL_Token: sessionStorage.getItem('apl_token') || '',
      'Cache-Control': 'no-cache',
    };

    return axios({
      method: 'post',
      baseURL: BASE_API().trimEnd('/'),
      url: '/api/v1/shipping/GetShippingMethods',
      data: request,
      headers,
      cancelToken: cancelTokenSource.token,
    })
      .then((response) => {
        sessionStorage.setItem('apl_token', response.headers['apl_token']);
        sessionStorage.setItem('apl_token_timeout', response.headers['apl_token_timeout']);
        return response;
      })
      .then((response) => {
        console.log('Shipping Methods Response:');
        console.log(response);

        const { data: methods } = response;
        const { methodId } = shipping;

        let activeIndex = methods.findIndex((method) => method.shippingMethodId === methodId);
        if (activeIndex < 0 && methods.length > 0) activeIndex = 0;

        handleShippingMethodsCallback({
          activeIndex,
          loading: false,
          methods,
        });
      })
      .catch((error) => {
        let loading;
        if (axios.isCancel(error)) {
          console.log('Shipping methods request was cancelled!');
          loading = true;
        } else {
          console.log('Shipping Methods Error:');
          loading = false;
        }
        console.log(error);
        handleShippingMethodsCallback({
          activeIndex: -1,
          loading,
          methods: [],
        });
      });
  };
};

export const recalculatePriceAsync = (cancelTokenSource) => {
  return (dispatch, getState) => {
    const state = getState();

    const needToRecalculatePrice = getIfCurrentBrandNeedsToRecalculatePrice(state);
    if (!needToRecalculatePrice) return;

    const validation = getQuantityValidation(state);
    if (!validation.isValid) return;

    const yearQuestion = getQuestion(state, YearQuestionCode);
    let calendarItemComponentIds = [];
    if (!!yearQuestion) {
      const bomSelection = getFinalBomOptionsSelection(state);
      const { generalOptions, pseudoParentChildQuestionOptionDictionaries } = bomSelection;
      calendarItemComponentIds = [
        ...generalOptions,
        ...pseudoParentChildQuestionOptionDictionaries.flatMap((dict) => Object.values(dict)).flat(),
      ].map((option) => option.componentId);
    }

    const parameters = getParameters(state);
    const { coupon, refId: configId, vendorId } = parameters;

    const itemId = getItemId(state);
    const quantity = getQuantity(state);

    const price = getPrice(state);
    const { isClearance, isEveryDayLowPrice: isEverydayDeal, priceTable } = price;
    const isNoDiscountAllowed =
      !!priceTable &&
      priceTable.some((row) => !!row && !!row.priceType && row.priceType.trim().toUpperCase() === 'NDA');

    const headers = {
      APL_Token: sessionStorage.getItem('apl_token') || '',
      'Cache-Control': 'no-cache',
    };

    const request = {
      calendarItemComponentIds,
      configId,
      coupon: coupon || '',
      isClearance,
      isEverydayDeal,
      isNoDiscountAllowed,
      itemId,
      quantity,
      vendorId,
    };
    console.log('Price Recalculation Request:');
    console.log(request);

    dispatch(startPriceRecalculation());

    return axios({
      method: 'post',
      baseURL: BASE_API().trimEnd('/'),
      url: '/api/v1/Cart/RecalculatePrice',
      data: request,
      headers,
      cancelToken: cancelTokenSource.token,
    })
      .then((response) => {
        sessionStorage.setItem('apl_token', response.headers['apl_token']);
        sessionStorage.setItem('apl_token_timeout', response.headers['apl_token_timeout']);
        return response;
      })
      .then((response) => {
        console.log('Price Recalculation Response:');
        console.log(response);
        dispatch(savePriceRecalculationResponse(response.data));
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.log('Price recalculation was cancelled!');
        } else {
          console.log('Price Recalculation Error:');
          dispatch(priceRecalculationFailed());
        }
        console.log(error);
      });
  };
};
